export default __webpack_public_path__ + "static/media/KCElectricalContractor.1b37d2c3.pdf";